import { useSettings } from "@/context/SettingsContext";
import { SocialIcon } from "@/lib/socials";

export default function WhatsAppButton() {
  const { settings } = useSettings();
  const number = (settings.whatsapp_number || "").replace(/\D/g, "");

  if (settings.whatsapp_enabled === false || !number) return null;

  const message = settings.whatsapp_message || "";
  const href = `https://wa.me/${number}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
  const label = settings.whatsapp_label || "Chat with us on WhatsApp";

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      title={label}
      data-testid="whatsapp-floating-button"
      className="fixed right-5 bottom-5 md:right-7 md:bottom-7 z-40 w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_8px_30px_rgba(0,0,0,0.35)] hover:bg-[#20bd5a] hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-background transition-all"
    >
      <SocialIcon platform="whatsapp" size={29} strokeWidth={1.7} />
    </a>
  );
}